export default __webpack_public_path__ + "static/media/cube.4ed012d3.svg";